import { Component, OnInit } from '@angular/core';
import { IFormulario } from 'src/app/models/Formulario';
import { IGenericResponse } from 'src/app/models/IGenericResponse';
import { NuevoAdministrador, ParametrosAdministrador } from 'src/app/models/RegistrarAdministrador';
import { NotificationService } from 'src/app/service/notificaciones.service';
import { FormulariosState } from 'src/app/state/formularios.state';
import { ActivatedRoute } from '@angular/router';
import { GestionarAdministradoresService } from 'src/app/service/gestion/gestionar-administradores.service';
import { GestionarDistribuidoresService } from 'src/app/service/gestion/gestionar-distribuidores.service';
import { Distribuidores } from 'src/app/models/Distribuidores';
@Component({
  selector: 'app-resgistro-administrador',
  templateUrl: './resgistro-admin.component.html',
  styleUrls: ['./resgistro-admin.component.css']
})

export class ResgistroAdminComponent implements OnInit{

  formulario: IFormulario[] = [];
  url_imagenes: string[] = ["assets/vodafone.png"];
  url_imagen_bottom: string[] = ["assets/Imagen1.png"];
  opcion_seleccionada: string | null = '';

  constructor(private notificacionesService: NotificationService, private route: ActivatedRoute, 
              private formulariosState: FormulariosState,
              private GestionarAdministradoresService: GestionarAdministradoresService,
              private GestionarDistribuidoresService: GestionarDistribuidoresService) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.opcion_seleccionada = params.get('opcion');
      if (this.opcion_seleccionada) {
        this.cargarFormulario(this.opcion_seleccionada);
      }
    });
  }

  private cargarFormulario(opcion: string): void {
    switch (opcion) {
      case 'administrador':
        this.formulario = this.formulariosState.formulario_crear_administrador;
      break;
      case 'distribuidor':
        this.formulario = this.formulariosState.formulario_crear_distribuidor;
      break;
      default:
      break;
    }
  }
  onRecibirFormulario(credenciales: any) {
    switch (this.opcion_seleccionada) {
      case 'administrador':
        this.crearAdministrador(credenciales);
      break;
      case 'distribuidor':
        this.crearDristribuidor(credenciales);
      break;
      default:
      break;
    }
  }

  crearAdministrador(credenciales: NuevoAdministrador): void {  
    if((credenciales.usuario === credenciales.usuario_repetido) && (credenciales.password === credenciales.password_repetido)){
      let nuevo_administrador: ParametrosAdministrador = {
        usuario: credenciales.usuario,
        password: credenciales.password,
        email: credenciales.email
      }
      this.GestionarAdministradoresService.crearAdministrador(nuevo_administrador).subscribe((response: IGenericResponse) => {
        if(response.error == '') this.notificacionesService.notificacionSuccess(response.message);
        else this.notificacionesService.notificacionError(response.message);
      });
    } 
    else if(credenciales.usuario !== credenciales.usuario_repetido) this.notificacionesService.notificacionError("Los usuarios introducidos no coinciden.");
    else if(credenciales.password !== credenciales.password_repetido) this.notificacionesService.notificacionError("Las contraseñas introducidas no coinciden.");
  }

  crearDristribuidor(credenciales: Distribuidores): void {
    this.GestionarDistribuidoresService.crearDistribuidor(credenciales).subscribe((response: IGenericResponse) => {
      if(response.error == '') this.notificacionesService.notificacionSuccess(response.message);
      else this.notificacionesService.notificacionError(response.message);
    })
  }
}
